import React from "react"
export function EuFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Double-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__EU" fillRule="nonzero">
          <g id="prefix__eu">
            <path id="prefix__Path" fill="#039" d="M12 16H0V0h24v16z" />
            <g id="prefix__Group" transform="translate(6 2)" fill="#FC0">
              <path
                id="prefix__Path"
                d="M6.066 0l.195.595.633-.002-.513.369.197.598-.513-.37-.513.37.197-.598-.513-.369h.634zM8.683.696l.195.597.634.001-.514.371.197.597-.513-.37-.513.37.197-.597-.513-.371h.632zM10.6 2.598l.194.597h.632l-.514.37.196.597-.513-.369-.513.369.197-.597-.514-.37h.632zM11.301 5.195l.194.595h.632l-.514.37.196.598-.513-.369-.513.369.197-.598-.514-.37h.631zM10.6 7.79l.195.593h.632l-.512.369.196.598-.513-.37-.513.37.197-.595-.514-.374.632-.002zM8.684 9.69l.195.593h.634l-.514.369.196.598-.513-.37-.513.37.197-.597-.514-.37.632-.002zM6.066 10.387l.195.595.634-.002-.514.372.197.598-.513-.371-.513.37.197-.597-.513-.372h.632zM3.449 9.69l.193.593h.636l-.514.369.196.598-.513-.37-.514.37.197-.597-.513-.37.632-.002zM1.535 7.79l.195.593h.635l-.514.369.196.598-.514-.37-.514.37.197-.597-.513-.37.632-.002zM.835 5.195l.194.595h.63l-.514.37.197.598-.513-.369-.513.369.197-.598L0 5.79h.632zM1.535 2.598l.195.597h.634l-.513.37.196.597-.514-.369-.514.369.197-.597-.513-.37h.632zM3.452.696l.195.597.634.001-.513.371.196.595-.514-.369-.514.369.197-.597-.513-.37h.632z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
